import _ from "lodash";
import produce from "immer";
import axios from "axios";
import strings from "../../../res/strings";
import { setAppProcessing, setAppSuccess, setAppError } from "../../common";

export const ACTIVATE_ACCOUNT = "activation/ACTIVATE_ACCOUNT";
export const RESEND_ACTIVATION_EMAIL = "activation/RESEND_ACTIVATION_EMAIL";

const ACTIVATE_ACCOUNT_ERRORS = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
  STALE_TOKEN: {
    message: strings.lib_authentication_state_error_activate_stale,
  },
  INVALID: {
    message: strings.lib_authentication_state_error_activation_invalid,
  },
};
const RESEND_ACTIVATION_EMAIL_ERRORS = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
  ACTIVATED_OR_UNREGISTERED: {
    message:
      strings.lib_authentication_state_error_email_activated_unregistered,
  },
};

const initialState = {};

export default (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case ACTIVATE_ACCOUNT: {
        break;
      }

      case RESEND_ACTIVATION_EMAIL: {
        break;
      }

      default: {
        break;
      }
    }
  });

export const activateAccount = (
  { values, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context: "lib_activation.activateAccount",
          message: strings.lib_common_state_loading,
        }
      )
    );

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env.REACT_APP_API_LIB_ACTIVATION_ACTIVATE_ACCOUNT,
        values
      )
      .then((response) => {
        dispatch({ type: ACTIVATE_ACCOUNT });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? { context: "lib_activation.activateAccount" },
            history
          )
        );
      })
      .catch((errorResponse) => {
        let error = ACTIVATE_ACCOUNT_ERRORS.DEFAULT;
        if (_.get(errorResponse, "response.status") === 400) {
          error = ACTIVATE_ACCOUNT_ERRORS.INVALID;
        } else if (_.get(errorResponse, "response.status") === 403) {
          error = ACTIVATE_ACCOUNT_ERRORS.STALE_TOKEN;
        }

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  notificationType: "alert",
                  context: "lib_activation.activateAccount",
                  ...error,
                },
            history
          )
        );
      });
  };
};

export const resendActivationEmail = (
  { values, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context: "lib_activation.resendActivationEmail",
          message: strings.lib_common_state_loading,
        }
      )
    );

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env.REACT_APP_API_LIB_ACTIVATION_RESEND_ACTIVATION_EMAIL,
        values
      )
      .then((response) => {
        dispatch({ type: RESEND_ACTIVATION_EMAIL });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? {
                  context: "lib_activation.resendActivationEmail",
                },
            history
          )
        );
      })
      .catch((errorResponse) => {
        let error = RESEND_ACTIVATION_EMAIL_ERRORS.DEFAULT;
        if (_.get(errorResponse, "response.status") === 400) {
          error = RESEND_ACTIVATION_EMAIL_ERRORS.ACTIVATED_OR_UNREGISTERED;
        }

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  notificationType: "alert",
                  context: "lib_activation.resendActivationEmail",
                  ...error,
                },
            history
          )
        );
      });
  };
};
